<ion-app>
  <ion-split-pane contentId="main" disabled="true">
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
